import React, {Suspense} from 'react';
import './App.css';
import {useSessionContext} from "./util/SessionContext";
import {theme} from "./theme";
import {StyledEngineProvider, ThemeProvider} from '@mui/material';
import {AppContextProvider} from "./util/AppContext";
import Layout from "./components/Layout";
import InactiveLogout from "./components/Logout/InactiveLogout";
import * as go from 'gojs';
import { ReactDiagram } from 'gojs-react';


/**
 * Diagram initialization method, which is passed to the ReactDiagram component.
 * This method is responsible for making the diagram and initializing the model and any templates.
 * The model's data should not be set here, as the ReactDiagram component handles that via the other props.
 */
function initDiagram() {
  // set your license key here before creating the diagram: go.Diagram.licenseKey = "...";
  const diagram =
    new go.Diagram(
      {
        'undoManager.isEnabled': true,  // must be set to allow for model change listening
        // 'undoManager.maxHistoryLength': 0,  // uncomment disable undo/redo functionality
        'clickCreatingTool.archetypeNodeData': { text: 'new node', color: 'lightblue' },
        model: new go.GraphLinksModel(
          {
            linkKeyProperty: 'key'  // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
          })
      });

  // define a simple Node template
  diagram.nodeTemplate =
    new go.Node('Auto')  // the Shape will go around the TextBlock
      .bindTwoWay('location', 'loc', go.Point.parse, go.Point.stringify)
      .add(
        new go.Shape('RoundedRectangle',
            { name: 'SHAPE', fill: 'white', strokeWidth: 0 })
          // Shape.fill is bound to Node.data.color
          .bind('fill', 'color'),
        new go.TextBlock({ margin: 8, editable: true })  // some room around the text
          .bindTwoWay('text')
      );

  return diagram;
}

function handleModelChange(changes) {
  alert('GoJS model changed!');
}

function App() {
    const sessionContext = useSessionContext();

/*
    useEffect(() => {
        if (!sessionContext.valid()) {
            if (sessionContext.size() > 0) {
                console.log(`session is not valid but has content... resetting. ${JSON.stringify(sessionContext.dump())}`);
                sessionContext.reset();
            }
        }
    }, [sessionContext]);
*/
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Suspense fallback={<div>Loading...</div>}>
                    <AppContextProvider value={{sessionContext}}>
                        <Layout/>
                        <InactiveLogout/>
                    </AppContextProvider>
                </Suspense>
            </ThemeProvider>
        </StyledEngineProvider>
    );
/*
    return (
        <div>
            <ReactDiagram initDiagram={initDiagram} divClassName='diagram-component'
                nodeDataArray={[
                  { key: 0, text: 'Alpha', color: 'lightblue', loc: '0 0' },
                  { key: 1, text: 'Beta', color: 'orange', loc: '150 0' },
                  { key: 2, text: 'Gamma', color: 'lightgreen', loc: '0 150' },
                  { key: 3, text: 'Delta', color: 'pink', loc: '150 150' }
                ]}
                linkDataArray={[
                  { key: -1, from: 0, to: 1 },
                  { key: -2, from: 0, to: 2 },
                  { key: -3, from: 1, to: 1 },
                  { key: -4, from: 2, to: 3 },
                  { key: -5, from: 3, to: 0 }
                ]}
                onModelChange={handleModelChange}
            />
        </div>
    )
    */
}

export default App;